import { Box, Typography } from '@mui/material';
import { Modal } from 'antd';
import { useEffect, useState } from 'react';
import useScreenSize from '../util/customHooks/useScreenSize';
import {ReactComponent as CloseButton} from '../assets/images/close_btn.svg'
import { useDispatch } from 'react-redux';
import { setModalOpen } from '../feature/application/appSlice';

const PromptMessageModel = ({ isModalOpen = false, handlePromptCancel, message = "" }) => {
    const [promptMessage, setPromptMessage] = useState(message);

    const { isMobile, isTablet, isLaptop } = useScreenSize();
   const dispatch= useDispatch();
    useEffect(() => {
        setPromptMessage(message);
        dispatch(setModalOpen(isModalOpen));
    }, [message, isModalOpen]);


    return (
        <Modal
            open={isModalOpen}
            footer={null}
            width={
                isMobile ? 350 :
                    isTablet ? 400 :
                        isLaptop ? 500 : 600
            }
            centered
            maskClosable={false}
            closeIcon={null}
            style={{
                marginTop: "8%",
            }}
        >

            <CloseButton onClick={handlePromptCancel} style={{ position: 'absolute', top: 10, right: 10, cursor: 'pointer' }} />
            
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'flex-start',
                    flexWrap: 'wrap',
                    width: '100%',
                    minHeight: '120px',
                    maxHeight: '200px',
                    overflowY: 'auto',
                    marginTop: "25px",
                    padding: '10px'
                }}
            >
                <Typography>
                    {promptMessage}
                </Typography>
            </Box>

        </Modal>
    );
};

export default PromptMessageModel;
